<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <b-button variant="primary mr-1" @click="exportxls()"><i class="fa fa-file-excel-o"></i> Export</b-button>
          <b-button variant="primary mr-1" @click="reprosesBulkconfirm()"><i class="fa fa-refresh"></i> Reprocess
            OS</b-button>
        </div>
      </div>
      <b-row>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Due Date</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.tgl1" type="date" style="max-width:80px"></b-form-input>
            <b-input-group-prepend><span class="input-group-text">-</span></b-input-group-prepend>
            <b-form-input v-model="tblData.tgl2" type="date" style="max-width:80px"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Loan</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.loan_id"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Disbursement</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.type_disbursement" :options="disbursement_options" class=""> </b-form-select>
            <b-form-select v-model="tblData.comparison_disbuesement" :options="comparison_option" class="">
            </b-form-select>
            <my-number class="form-control text-right" v-model="tblData.disbursementamt" :precision="0"></my-number>
          </b-input-group>
        </b-col>
        <b-col>
          <b-input-group>
            <b-input-group-prepend>
              <label>Debt. Fullname</label>
            </b-input-group-prepend>
            <b-form-input v-model="tblData.debtorFullName"></b-form-input>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Outstanding</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.type_os" :options="type_os_options" class=""> </b-form-select>
            <b-form-select v-model="tblData.comparison" :options="comparison_option" class=""> </b-form-select>
            <my-number class="form-control text-right" v-model="tblData.osamt" :precision="0"></my-number>
          </b-input-group>
          <b-input-group>
            <b-input-group-prepend>
              <label>Project</label>
            </b-input-group-prepend>
            <b-form-select v-model="tblData.pjxkey" :plain="true" :options="projectsFilt"></b-form-select>
            <b-button class="btn btn-success ml-1" @click="refresh()">
              <i class="fa fa-refresh"></i> Apply
            </b-button>
            <b-button class="btn btn-secondary ml-1" @click="clearFilter()">
              <i class="fa fa-eraser"></i>Clear
            </b-button>
          </b-input-group>
        </b-col>
      </b-row>
      <b-table class="mb-0" ref="table" outlined responsive striped hover small style="font-size:smaller;" :items="data"
        :fields="tblFields" :current-page="tblData.page" :per-page="tblData.limit" :sort-by.sync="tblData.sortBy"
        :sort-desc.sync="tblData.sortDesc" :key="tblData.limit" @row-clicked="rowClicked" show-empty :busy="isBusy">
        <template #thead-top="data">
          <b-tr>
            <b-th colspan="6"></b-th>
            <b-th variant="success" colspan="2" class="text-center">DISBURSEMENT</b-th>
            <b-th variant="primary" colspan="3" class="text-center">REPAYMENT</b-th>
            <b-th variant="warning" colspan="3" class="text-center">OUTSTANDING</b-th>
          </b-tr>
        </template>
        <template v-slot:cell(index)="data">{{ ((tblData.page - 1) * tblData.limit) + (data.index + 1) }}</template>
        <template v-slot:cell(installmentEndDate)="data">{{ data.item.installmentEndDate | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(last_disbursed_date)="data">{{ data.item.last_disbursed_date | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(last_update_server)="data">{{ data.item.last_update_server | moment("YYYY-MM-DD HH:mm")
        }}</template>

        <template v-slot:cell(repayment_date)="data">{{ data.item.repayment_date | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(installmentStartDate)="data">{{ data.item.installmentStartDate | moment("YYYY MMM DD")
        }}</template>
        <template v-slot:cell(disbursement_amount)="data">{{ data.item.disbursement_amount | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(interest_ttl)="data">{{ data.item.interest_ttl | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(principal_repayment)="data">{{ data.item.principal_repayment | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(interest_repaid)="data">{{ data.item.interest_repaid |
          numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(total_repayment)="data">{{ (data.item.principal_repayment + data.item.interest_repaid) |
          numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(interest_charged_sum)="data">{{ data.item.interest_charged_sum | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(principal_outstanding)="data">{{ data.item.principal_outstanding | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(interest_outstanding)="data">{{ data.item.interest_outstanding | numFormat('0,0.00')
        }}</template>
        <template v-slot:cell(ttl_outstanding)="data">{{ (data.item.principal_outstanding +
          data.item.interest_outstanding) | numFormat('0,0.00')
        }}</template>

        <template v-slot:cell(genderCode)="data">
          <span v-if="data.item.genderCode == 'L'">Male</span>
          <span v-else-if="data.item.genderCode == 'P'">Female</span>
        </template>
        <template v-slot:cell(empty)="data">
          <h4>{{ data.emptyText }}</h4>
        </template>
        <template v-slot:cell(emptyfiltered)="data">
          <h4>{{ data.emptyFilteredText }}</h4>
        </template>
        <template #table-busy>
          <div class="text-center text-danger my-2">
            <b-spinner class="align-middle"></b-spinner>
            <strong>Loading...</strong>
          </div>
        </template>
      </b-table>
      <b-row class="mt-2">
        <b-col cols="4">
          <div>
            Showing {{ (tblData.page - 1) * tblData.limit + 1 }}
            to
            <span v-if="((tblData.page * tblData.limit) > tblData.total)">{{ tblData.total }}</span>
            <span v-else>{{ tblData.page * tblData.limit }}</span>
            of {{ tblData.total | numFormat }} entries
          </div>
        </b-col>
        <b-col cols="4">
          <b-form-group label-cols="3" label style="margin-top:0 !important;">
            <b-input-group>
              <b-input-group-prepend class="mr-2">
                <label>Limit per page</label>
              </b-input-group-prepend>
              <div class="d-flex">
                <b-form-select :options="[10, 15, 20, 25]" :plain="true" v-model="tblData.limit" size="sm"
                  style="width:80px" />
              </div>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col cols="4">
          <b-pagination align="right" :total-rows="tblData.total" :per-page="tblData.limit" v-model="tblData.page">
          </b-pagination>
        </b-col>
      </b-row>
    </b-card>
    <b-modal v-model="showReprosesBulkConfirm" title="Reproses Outstanding Record?" :centered="true" @ok="reprosesbulk">
      <p class="mb-1">All record is about to be permanently reprocess</p>
      <p class="font-weight-bold m-0 text-danger">Warning: You can't undo this action.</p>
    </b-modal>
    <loading :active.sync="isLoading" :height="128" :width="128" color="#4b8cf4"></loading>
    <b-modal ref="modalprogress" v-model="progessupload.show" :centered="true" hide-footer>
      <template #modal-title>
        PROGRESS {{ progessupload.title }}
      </template>
      <b-progress :value="progessupload.value" :max="progessupload.max" variant="success" striped :animated="true"
        show-progress></b-progress>
    </b-modal>
  </div>
</template>
  
<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import myNumber from "../../components/my-number.vue";
import crud from "../../apis/crud";
import loan from "../../apis/loan";
toastr.init();
export default {
  components: { Loading, myNumber },
  data() {
    return {
      showFilter: true,
      isBusy: false,
      isLoading: false,
      showReprosesBulkConfirm: false,
      type_os_options: [
        { value: null, text: 'Please select an option' },
        { value: 'principal', text: 'Principal' },
        { value: 'interest', text: 'Interest' },
        { value: 'OS', text: 'OS Total' },

      ],
      projectsFilt: [{
        value: '', text: '-- ALL --'
      }],
      disbursement_options: [
        { value: null, text: 'Please select an option' },
        { value: 'principal', text: 'Principal' },
        { value: 'interest', text: 'Interest' },
      ],
      comparison_option: [
        { value: null, text: 'Please select an option' },
        { value: '=', text: 'Equal to' },
        { value: '>', text: 'Greater than' },
        { value: '>=', text: 'greater than or equal to' },
        { value: '<', text: 'Less than' },
        { value: '<=', text: 'less than or equal to' },
      ],
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "partnerLoanApplicationNumber",
        sortDesc: false,
        tablename: 'loan',
        tgl1: moment().startOf('M').format('YYYY-MM-DD'), tgl2: moment().format('YYYY-MM-DD'),
        loan_id: '',
        customerID: '', debtorFullName: '', type_os: 'principal', comparison: '>', osamt: 0,
        type_disbursement: 'principal', comparison_disbuesement: '>', disbursement_amount: 0,
        pjxkey: ''
      },
      dataList: {
        debiturStatus: dropdown.debiturStatus
      },
    };
  },
  computed: {
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "No.",
          thClass: "text-center",
          sortable: true
        },
        {
          key: "partnerLoanApplicationNumber",
          label: "Loan App. Number",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "installmentEndDate",
          label: "Due Date",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "customerID",
          label: "Customer ID",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "debtorFullName",
          label: "Customer Fullname",
          thClass: "text-center",
          thStyle: "min-width:100px",
          sortable: true
        },
        {
          key: "pjxname",
          label: "Project Name",
          thClass: "text-center",
          sortable: true
        },
        // {
        //   key: "last_disbursed_date",
        //   label: "Last Disbursement Date",
        //   thClass: "text-center",
        //   sortable: true
        // },
        // {
        //   key: "repayment_date",
        //   label: "Repayment Date",
        //   thClass: "text-center",
        //   sortable: true
        // },
        {
          key: "disbursement_amount",
          label: "Disbursement Amt",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "interest_ttl",
          label: "Interest Amt (estimate)",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },

        {
          key: "principal_repayment",
          label: "Principal/Refund Amt.",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "interest_repaid",
          label: "Interest Amt.",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "total_repayment",
          label: "TOTAL REPAYMENT",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "principal_outstanding",
          label: "Principal",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "interest_outstanding",
          label: "Interest",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "ttl_outstanding",
          label: "TOTAL OUTSTANDING",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "dpd",
          label: "DPD",
          thClass: "text-center",
          tdClass: 'text-right',
          sortable: true
        },
        {
          key: "last_update_server",
          label: "Last Calc",
          thClass: "text-center",
          sortable: true
        },

      ];
      return fields;
    },
    progessupload() {
      let progessupload = this.$store.state.progessupload;
      if (progessupload && progessupload.refreshdata) {
        this.refresh();
        this.$refs["modalprogress"].hide();
        this.$store.commit("progessupload", {});
      }
      return progessupload;
    },
  },
  async created() {
    const [projects] = await Promise.all([crud.list({
      tablename: 'project',
      page: 1,
      limit: 10000,
      total: 0,
      sortBy: 'pjxname',
      sortDesc: false,
      customQuery:`container=!`
    })]);
    projects.forEach(tp => {
      tp.value= tp.pjxkey
      tp.text= tp.pjxname
      this.projectsFilt.push(tp)
    });
    
    this.$store.commit("progessupload", {});

  },
  methods: {
    rowClicked(record, index) {
      if ((this.model) && (this.model._rowVariant)) {
        delete this.model._rowVariant;
      }
      this.model = record;
      record._rowVariant = 'info';
      this.$forceUpdate();
      // }
    },
    async data() {
      try {
        this.isBusy = true;
        const filter = this.$store.state.filter;
        let filtered = false;
        for (var key in filter.debiturList) {
          this.tblData[key] = filter.debiturList[key];
          filtered = true;
        }
        if (filtered === true) {
          this.showFilter = filtered;
          delete filter.debiturList;
          this.$store.commit("filter", filter);
          // this.$store.commit("filter", {});
        }
        this.tblData.sortDir = this.tblData.sortDesc ? "desc" : "asc";
        if (this.tblData.tgl1 || this.tblData.tgl2) {
          if ((this.tblData.tgl2 || "") == "") {
            this.tblData.tgl2 = this.tblData.tgl1;
          }
        }
        const list = await loan.list(this.tblData);
        this.isBusy = false;
        console.log('list', list)
        return list;
      } catch (error) {
        this.isBusy = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async exportxls() {
      try {
        this.isLoading = true;
        await loan.exportxls(this.tblData);
        this.isLoading = false;
      } catch (error) {
        this.isLoading = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    reprosesBulkconfirm() {
      this.showReprosesBulkConfirm = true;
    },
    async reprosesbulk() {
      try {
        this.isLoading = true;
        await loan.prosesOutstandingLoanBulk(this.tblData);
        this.isLoading = false;
        toastr.success('Records will be proceseed in BACKGROUND SERVICE,plase wait.', "SUCCESS", 10000);
      } catch (error) {
        this.isLoading = false;
        toastr.error(error.message, "ERROR MESSAGE", 10000);
      }
    },
    async refresh() {
      try {
        this.$refs.table.refresh();
      } catch (error) {
        this.isBusy = false;
        if (error.message) {
          toastr.error(error.message, "ERROR MESSAGE", 10000);
        } else {
          toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
        }
      }
    },
    clearFilter() {
      this.tblData = {
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "partnerLoanApplicationNumber",
        sortDesc: false,
        tablename: 'loan',
        loan_id: '', tgl1: '', tgl2: '', customerID: '', debtorFullName: ''
      };
      this.refresh();
    },

    close() {
      router.push({ name: "paylater.home" });
    }
  }
};
</script>